<template>
  <div class="text-h4 darkgrey--text mb-4 ref-subtitle"><slot></slot></div>
</template>

<script>
import { defineComponent } from '@vue/composition-api';

export default defineComponent({});
</script>
